cc.Class({
    extends: cc.Component,

    onEnable () {
        const iFrame = document.getElementsByTagName('iframe')[0];
        if (iFrame) {
            document.getElementsByTagName('iframe')[0].style.display = 'block';
        }
    },

    onDisable () {
        const iFrame = document.getElementsByTagName('iframe')[0];
        if (iFrame) {
            document.getElementsByTagName('iframe')[0].style.display = 'none';
        }
    }
});
